import api from '@/utils/api';
import {
    createSingleFileFormData,
    mergeUploadResults,
    toFileArray
} from '@/utils/fileUploadQueue';

export default new class ReportsApi {
    getReports(params = {}) {
        return api.get('/api/reports', {params}).then(({data}) => data);
    }

    getFilterOptions(params = {}) {
        return api.get('/api/reports/filter-options', {params}).then(({data}) => data);
    }

    getAccessSettings() {
        return api.get('/api/reports/access-settings').then(({data}) => data);
    }

    updateAccessSettings(accessConfig) {
        return api.put('/api/reports/access-settings', {access_config: accessConfig}).then(({data}) => data);
    }

    getObjectAccess(params = {}) {
        return api.get('/api/reports/object-access', {params}).then(({data}) => data);
    }

    updateObjectAccess(id, accessConfig) {
        return api.put(`/api/reports/object-access/${id}`, {access_config: accessConfig}).then(({data}) => data);
    }

    getReport(id) {
        return api.get(`/api/reports/${id}`).then(({data}) => data);
    }

    getActivity(id) {
        return api.get(`/api/reports/${id}/activity`).then(({data}) => data);
    }

    getMediaPreview(id, params = {}) {
        return api.get(`/api/reports/${id}/media-preview`, {params}).then(({data}) => data);
    }

    commitTempPhotos(id, tempIds) {
        return api.post(`/api/reports/${id}/photos/commit-temp`, {
            tempIds
        }, {
            ignoreModal: true
        }).then(({data}) => data);
    }

    resendPhotos(id) {
        return api.post(`/api/reports/${id}/photos/resend`).then(({data}) => data);
    }

    resendTelegramReport(id) {
        return api.post(`/api/reports/${id}/telegram/resend`).then(({data}) => data);
    }

    addComment(id, text) {
        return api.post(`/api/reports/${id}/comments`, {text}).then(({data}) => data);
    }

    editComment(id, commentId, text) {
        return api.put(`/api/reports/${id}/comments/${commentId}`, {text}).then(({data}) => data);
    }

    deleteComment(id, commentId) {
        return api.delete(`/api/reports/${id}/comments/${commentId}`).then(({data}) => data);
    }

    async uploadCommentFiles(id, commentId, files) {
        const results = [];
        for (const file of toFileArray(files)) {
            const formData = createSingleFileFormData('files', file, {}, file.name || 'file');
            const {data} = await api.post(`/api/reports/${id}/comments/${commentId}/files`, formData, {
                headers: {'Content-Type': 'multipart/form-data'}
            });
            results.push(data);
        }
        return mergeUploadResults(results);
    }

    deleteCommentFile(id, commentId, fileId) {
        return api.delete(`/api/reports/${id}/comments/${commentId}/files/${fileId}`).then(({data}) => data);
    }
}
